import { useCookieValue } from './useCookieValue';

interface CookieConfig {
  opco: string;
  market: string;
  locale: string;
}

const DEFAULT_COOKIE_CONFIG: { [key in keyof CookieConfig]: string } = {
  opco: 'BA',
  market: 'GB',
  locale: 'en-GB',
};

const COOKIE_NAMES: { [key in keyof CookieConfig]: string } = {
  opco: 'AVIOS_OPCO',
  market: 'AVIOS_OPCO_MARKET',
  locale: 'AVIOS_OPCO_LANG',
};

export const useCookies = () => {
  const [locale, setLocale] = useCookieValue(COOKIE_NAMES.locale, DEFAULT_COOKIE_CONFIG.locale);
  const [market, setMarket] = useCookieValue(COOKIE_NAMES.market, DEFAULT_COOKIE_CONFIG.market);
  const [opco, setOpco] = useCookieValue(COOKIE_NAMES.opco, DEFAULT_COOKIE_CONFIG.opco);

  return {
    locale,
    market,
    opco,
    setOpco,
    setMarket,
    setLocale,
  };
};
